function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernmentDataBreadcrumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16645_1565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.5C16.0967 1.5 16.669 1.73705 17.091 2.15901C17.5129 2.58097 17.75 3.15326 17.75 3.75V5.25H16.25V14.25C16.25 14.8467 16.0129 15.419 15.591 15.841C15.169 16.2629 14.5967 16.5 14 16.5H3.5C2.90326 16.5 2.33097 16.2629 1.90901 15.841C1.48705 15.419 1.25 14.8467 1.25 14.25V12.75H13.25V14.25C13.25 14.4337 13.3175 14.611 13.4395 14.7483C13.5616 14.8856 13.7298 14.9733 13.9122 14.9948L14 15C14.1837 15 14.361 14.9325 14.4983 14.8105C14.6356 14.6884 14.7233 14.5202 14.7448 14.3378L14.75 14.25V3H5C4.8163 3.00002 4.639 3.06747 4.50172 3.18954C4.36444 3.31161 4.27674 3.47981 4.25525 3.66225L4.25 3.75V11.25H2.75V3.75C2.75 3.15326 2.98705 2.58097 3.40901 2.15901C3.83097 1.73705 4.40326 1.5 5 1.5H15.5Z",
    fill: "#4A4A68",
    style: {
      fill: "#4A4A68",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16645_1565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#4A4A68",
    style: {
      fill: "#4A4A68",
      fillOpacity: 1
    },
    transform: "translate(0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentDataBreadcrumb);
export default __webpack_public_path__ + "static/media/government-data-breadcrumb.8088931a119bdd0eaa1ee6803b38f2f5.svg";
export { ForwardRef as ReactComponent };